/**
 * Creates an embed code that can be included on other HTML pages.
 *
 * @param width
 * @param height
 * @param params
 * @param embedUrl
 * @param vertical
 * @returns {string}
 */
const createEmbedCode = ({
  width = 560,
  height = 315,
  params = {},
  embedUrl = 'https://player.bnnvara.nl/',
  vertical = false,
} = {}) => {
  const url = new URL(embedUrl);

  Object.keys(params).forEach(key => url.searchParams.set(key, params[key]));

  // When vertical is true, let's swap the width and height variables.
  if (vertical) {
    /* eslint-disable no-param-reassign */
    [height, width] = [width, height];
    /* eslint-enable no-param-reassign */
  }

  const embedCode = `<iframe src="${url.toString()}" width="${width}" height="${height}" frameborder="0" scrolling="no" allowfullscreen></iframe>`;

  // eslint-disable-next-line
  return embedCode.replace(/\"/g, `&quot;`);
};

export default createEmbedCode;
